const isCompanyAdmin = loggedInUser =>
  loggedInUser &&
  loggedInUser["user"] &&
  loggedInUser["user"]["role"] &&
  loggedInUser["user"]["role"] === "company_admin"
    ? true
    : false;
export default isCompanyAdmin;
